@if (workspace(); as workspace) {
  <footer aria-label="Item location" class="border-t border-border px-8 py-4 text-sm text-subdued">
    {{ workspace === 'team' ? 'Team Workspace' : 'My Workspace'
    }}{{ (collection() ?? noun()) ? ' › ' + (collection() ?? noun()) : ''
    }}{{ archived() ? ' · Archived' : deleted() ? ' · Trash' : '' }}
  </footer>
}
